import React, { useState, useEffect } from 'react';
import { getReportCompany } from '../../services/reports/reportServices';
import { getInformationAgreement } from '../../services/company/company';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllClients } from '../../services/clients/clients';

import { Line } from "react-chartjs-2";


export const useReportCompany = () => {


    const [dateStart, setDateStart] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [dataViewCompany, setDataViewCompany] = useState([])
    const [loadingReport, setLoadingReport] = useState(false)
    const [createSweet] = useSweetAlert();
    const [detailTransactionsByCompany, setDetailTransactionsByCompany] = useState([])
    const [listCompanies, setListCompanies] = useState([])


    // * CONFIGURATION AGREEMENTS
    const [filterId, setFilterId] = useState(0)
    const [valuId, setValuId] = useState(0)
    const [listAgreement, setListAgreement] = useState([])

    const [countExams, setCountExams] = useState(0)
    const [countProfiles, setCountProfiles] = useState(0)
    const [id_company, setId_company] = useState(0)

    const [globalFilter, setGlobalFilter] = useState(null);




    // *USE EFFECT
    useEffect(() => {

        const today = new Date();
        const _Year = today.getFullYear();
        let _Month = today.getMonth() + 1;
        _Month = _Month < 10 ? `0${_Month}` : _Month;

        let _Day = today.getDate();
        _Day = _Day < 10 ? `0${_Day}` : _Day;

        const currentDate = `${_Year}-${_Month}-${_Day}`;

        setDateStart(currentDate);
        setDateEnd(currentDate);

        const getAllInitData = async () => {
            await getReport(currentDate, currentDate);
        };

        getAllInitData();
        getClients()
    }, []);



    //*TYPE CLIENT
    const getClients = async (_type) => {
        const company = await getAllClients();

        if (company?.length > 0) {
            const list = company?.map(_find => {
                return {
                    value: _find?.id_company,
                    label: _find?.code + "-" + _find?.name,
                }
            });
            setListCompanies(list);
        }
    }

    const handleChangeCompany = (e) => {
        if (e !== null) {
            setId_company({ value: e?.value, label: e?.label })

        } else {
            setId_company(null)
        }
    }



    const getReport = async (_dateStart, _dateEnd, _id_client = null, _id_agreement = null, _loading = false, _view1 = false) => {
        setLoadingReport(true)

        const response = await getReportCompany(_dateStart, _dateEnd, _id_client, _id_agreement, _loading, _view1);

        if (response?.code === 200) {

            setDataViewCompany(response?.data.detailTransactionsByCompany ?? []);
            setCountExams(response?.data.totalExams ?? 0);
            setCountProfiles(response?.data.totalProfiles ?? 0);
            setLoadingReport(false);
            setDetailTransactionsByCompany(response?.data.detailWorkOrderByClients ?? []);
            setGlobalFilter(null)
        }
        else {
            createSweet("create", "error", "Busqueda", "No se encontraron resultados");
            setLoadingReport(false);
        }
    }

    // * -----INFORMATION COMPANY
    const handleFilterByClient = async (_id_client, _valid, _loading = false, _view1 = false) => {
        let _start = dateStart;
        let _end = dateEnd;
        var _bool = false

        if (_valid) {

            _bool = true
        }
        searchAgreement(_id_client)


        if (!_start || !_end) {
            console.warn("Fechas no definidas, usando mes actual como fallback");

            const today = new Date();
            const _Year = today.getFullYear();
            let _Month = today.getMonth() + 1;
            _Month = _Month < 10 ? `0${_Month}` : _Month;

            _start = `${_Year}-${_Month}-01`;
            const lastDate = new Date(_Year, _Month, 0);
            _end = `${_Year}-${_Month}-${lastDate.getDate().toString().padStart(2, '0')}`;

            setDateStart(_start);
            setDateEnd(_end);
        }

        setFilterId(_id_client)
        await getReport(_start, _end, _id_client, (valuId !== 0 && valuId !== null) ? valuId.value : null, _loading, _view1);

    };

    // * --- CLEAN METHODS
    const handleCleanFilterByClient = async () => {

        const today = new Date();

        const _Year = today.getFullYear();
        let _Month = today.getMonth() + 1;
        let _Day = today.getDate();

        _Month = _Month < 10 ? `0${_Month}` : _Month;
        _Day = _Day < 10 ? `0${_Day}` : _Day;

        const dateStart = `${_Year}-${_Month}-${_Day}`;
        const dateEnd = `${_Year}-${_Month}-${_Day}`;

        await getReport(dateStart, dateEnd);
        setDateStart(dateStart);
        setDateEnd(dateEnd);

        setFilterId(0);
        setValuId(0);
        setListAgreement([]);
        setId_company(0)
        getClients()

    };


    // * -------FILTER 

    const parseDateLocal = (dateString) => {
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day);
    };

    const handleFilterDate = async () => {
        if (!dateStart || !dateEnd) {
            createSweet("warning", "Campos incompletos", "Debes seleccionar ambas fechas.");
            return;
        }

        const start = parseDateLocal(dateStart);
        const end = parseDateLocal(dateEnd);



        if (start.getFullYear() !== end.getFullYear() || start.getMonth() !== end.getMonth()) {
            createSweet("warning", "Rango inválido", "Solo puedes filtrar un único mes.");
            return;
        }



        await getReport(dateStart, dateEnd, (id_company !== 0 && id_company !== null) ? id_company.value : null);
        setValuId(0);
        setListAgreement([]);

    };

    const ReportCompanyChart = ({ dataViewCompany }) => {

        const top10 = dataViewCompany
            .map(item => ({
                ...item,
                total_tests: item.total_exams + item.total_profiles
            }))
            .sort((a, b) => b.total_tests - a.total_tests)
            .slice(0, 5);

        const data = {
            labels: top10.map(item => item.name_client),
            datasets: [
                {
                    label: "Total de pruebas",
                    data: top10.map(item => item.total_tests),
                    fill: false,
                    borderColor: "rgba(75, 192, 192, 1)",
                    backgroundColor: "rgba(75, 192, 192, 0.3)",
                    pointBorderColor: "rgba(75, 192, 192, 1)",
                    pointBackgroundColor: "#fff",
                    pointRadius: 6,
                    pointHoverRadius: 8
                }
            ]
        };

        const options = {
            responsive: true,
            plugins: {
                legend: { position: "top" },
                title: { display: true, text: "Empresas con más pruebas" }
            },
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        };

        return <Line data={data} options={options} />;
    };


    // ? CONFIGURATION SEARCH AGREEMENT
    const searchAgreement = async (_id) => {
        if (_id === 0) {

            return;
        }

        const getAgreement = await getInformationAgreement(_id);
        if (getAgreement !== null) {
            const list = getAgreement?.map(_find => {
                return {
                    value: _find?.id_agreement,
                    label: _find?.code,
                }
            });
            setListAgreement(list);
        }
    }


    const handleChangeAgreement = (e) => {
        if (e !== null) {
            setValuId({ value: e?.value, label: e?.label })

        } else {
            setValuId(null)
        }
    }
    const [loadingIdR, setLoadingIdR] = useState(null);


    // ? CONFIGURATION DOWNLOAD EXCEL
    const DownloadReportCxc = async (_id_client, _all) => {

        let _valid = _all === 0 ? _all : _id_client;
        setLoadingIdR(_valid);

        let _start = dateStart;
        let _end = dateEnd;

        if (!_start || !_end) {

            const today = new Date();
            const _Year = today.getFullYear();
            let _Month = today.getMonth() + 1;
            _Month = _Month < 10 ? `0${_Month}` : _Month;

            _start = `${_Year}-${_Month}-01`;
            const lastDate = new Date(_Year, _Month, 0);
            _end = `${_Year}-${_Month}-${lastDate.getDate().toString().padStart(2, '0')}`;

            setDateStart(_start);
            setDateEnd(_end);

        }


        const _token = localStorage.getItem("token");
        const _url = _id_client === null
            ? `/api/Reports/DownloadReportCompany/${dateStart}/${dateEnd}`
            : `/api/Reports/DownloadReportCompany/${dateStart}/${dateEnd}?id_company=${_id_client}${valuId && valuId !== 0 ? `&id_agreement=${valuId.value}` : ""}`;

        try {
            const response = await fetch(_url, {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + _token,
                    "Content-Type": "application/vnd.ms-excel",
                }),
            });

            if (!response.ok) throw new Error("Error en la descarga del archivo");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte_De_Empresas.xlsx");
            document.body.appendChild(link);
            link.style.display = "none";
            link.click();
        } catch (error) {
            console.error("Error al descargar el archivo:", error);
        } finally {
            setLoadingIdR(null);
        }
    };
















    return {
        countExams,
        countProfiles,
        dataViewCompany,
        dateStart, dateEnd,
        setDateStart, setDateEnd,
        handleFilterByClient,
        handleCleanFilterByClient,
        handleFilterDate,
        loadingReport,
        ReportCompanyChart,
        detailTransactionsByCompany,
        filterId,
        handleChangeAgreement,
        listAgreement,
        valuId,
        DownloadReportCxc,
        loadingIdR,
        listCompanies,
        handleChangeCompany,
        id_company,
        globalFilter, setGlobalFilter
    }
}

